<template>
  <v-dialog
    v-model="alwaysOpen"
    :fullscreen="isMobile"
    width="80%"
    max-width="512px"
    @click:outside="close"
  >
    <v-card class="form-dialog">
      <v-row>
        <v-col class="form-dialog__title">
          <h1>Delete {{ merchantName }}?</h1>
        </v-col>
      </v-row>
      <v-table class="table">
        <tr @click="deleteMerchantInfo" class="blackTr bottom-border">
          <td class="bottom-border">
            Delete all info and locations. Can't be undone
          </td>
          <td class="arrow--has-bottom-border">
            <img src="@/assets/arrows.svg" />
          </td>
        </tr>
        <tr @click="disableMerchant" class="blackTr">
          <td>Disable all locations and products</td>
          <td class="arrow"><img src="@/assets/arrows.svg" /></td>
        </tr>
        <tr class="backTr">
          <td colspan="2">
            <v-row class="form-dialog__button-wrap">
              <v-col cols="12">
                <v-btn
                  class="pkmn-button"
                  outlined
                  color="primary"
                  @click="close"
                >
                  Cancel
                </v-btn>
              </v-col>
            </v-row>
          </td>
        </tr>
      </v-table>
    </v-card>
  </v-dialog>
</template>

<script>
// import api from '@/helpers/api'
import * as config from '@/config/config'
import merchantHelpers from '@/helpers/merchant'

export default {
  name: 'FormDeleteMerchant',
  props: {
    data: Object
  },
  data() {
    return {
      alwaysOpen: true,
      errorMessage: null
    }
  },
  computed: {
    merchantName() {
      return this.$store.getters.currentMerchant.name
    },
    isMobile() {
      return window.innerWidth <= config.SMALL_SCREEN_BREAKPOINT
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    async deleteMerchantInfo() {
      await this.$store.dispatch('setShowOverlay', true)
      await merchantHelpers.deleteMerchant(this.$route.params.merchantId)
      this.$emit('merchantDeleted')
      await this.$store.dispatch('setShowOverlay', false)
    },
    async disableMerchant() {}
  },
  mounted() {
    // if user press Escape, close the dialog and clear all data
    // ONLY works if a component is NOT attacted to the view as a default (use v-if to decide whether a component is attacted or not)
    // Otherwise, all 'close' listener of components existing in a view will be notified
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.close()
      }
    })
  }
}
</script>

<style lang="scss" scoped>
@import '@/style/common';

.title-size {
  width: 302px !important;
}
.blackTr {
  color: var(--web-text-main, #333);
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 130%;
  height: 56px;
  vertical-align: middle;
  cursor: pointer;
}
.bottom-border {
  width: 426px;
  border-bottom: 1px solid #e5e5e5;
}

.arrow {
  width: 24px;
  align-content: right;
  text-align: right;

  &--has-bottom-border {
    border-bottom: 1px solid #e5e5e5;
  }
}
</style>
